'use client'

import { useTranslations } from 'next-intl'
import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import styles from './VisaRenewal.module.css'

function FadeIn({ children, className }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref, { once: false, margin: '-80px' })
  return (
    <motion.div ref={ref} className={className}
      initial={{ opacity: 0, y: 24 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  )
}

export default function VisaRenewal() {
  const t = useTranslations('VisaGuidePage.renewalTabs.visaRenewal')
  const DOC_KEYS = ['1', '2', '3', '4', '5'] as const

  return (
    <section className={styles.section}>
      <div className={styles.container}>

        <h2 className={styles.title}>{t('title')}</h2>

        {/* Required Documents */}
        <FadeIn className={styles.docsSection}>
          <h3 className={styles.sectionSubtitle}>{t('docsTitle')}</h3>
          <ul className={styles.docsList}>
            {DOC_KEYS.map((k) => (
              <li key={k} className={styles.docsItem}>
                <span className={styles.docsNumber}>{k}</span>
                <span className={styles.docsLabel}>{t(`docsList.${k}`)}</span>
              </li>
            ))}
          </ul>
        </FadeIn>

        <h3 className={styles.sectionSubtitle}>{t('stepsTitle')}</h3>

      </div>
    </section>
  )
}